<div #option
     class="≈flex-1 ≈inline-block hover:≈bg-primary-surface-hovered ≈cursor-pointer ≈p-2 md:≈p-3 ≈rounded-3 sm:≈rounded
         ≈select-none"
     [ngClass]="{
        '≈bg-primary-surface-hovered': isNavigated || selected,
        '≈mx-2 md:≈mx-3': !selected,
        '≈mr-2 md:≈mr-3 ≈ml-1.5 md:≈ml-2.5': selected
    }"
     (click)="select($event)">

  <ng-content>

  </ng-content>

</div>

<div *ngIf="selected" class="≈bg-primary-actions-default ≈rounded-r ≈w-1" [style.height.px]="option.getBoundingClientRect().height / 2">

</div>
